import { render, staticRenderFns } from "./orgToSign.vue?vue&type=template&id=5a6ae2d6&"
import script from "./orgToSign.vue?vue&type=script&lang=js&"
export * from "./orgToSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports